import { IElement, OneOfElements } from '@shared/models/project.model';
import { projectGuards } from '../../guards/project-guards.helpers';
import { ProjectChangeType } from '../update-engine.models';
import type { ProjectChangeMap } from '../update-engine.models';

/**
 * Update {@link IElement.category_id} for a category-backed element.
 *
 * @param element - Current element state
 * @param change - Category id payload
 * @returns Partial element or undefined when not an {@link ElementKind.Element}
 */
export const elementCategoryToChange = (
  element: OneOfElements,
  change: ProjectChangeMap[ProjectChangeType.ElementCategory],
): Partial<IElement> | undefined => {
  if (!projectGuards.is.element(element)) return undefined;
  if (element.category_id === change.categoryId) return undefined;

  return { category_id: change.categoryId };
};
